module.exports = __webpack_public_path__ + "media/assets/images/blog/floppy-small-010f677796368e7ec37acb07c63259e0.jpg";